import React, { useState } from 'react';
import { AlertTriangle, AlertCircle, Lightbulb, CheckSquare, Square } from 'lucide-react';

const GRUPPI = [
  { livello: 'grave', titolo: 'Da sistemare subito', icona: AlertTriangle, stile: 'bg-red-50 border-red-200', testo: 'text-red-900' },
  { livello: 'attenzione', titolo: 'Da controllare', icona: AlertCircle, stile: 'bg-amber-50 border-amber-200', testo: 'text-amber-900' },
  { livello: 'consiglio', titolo: 'Consigli', icona: Lightbulb, stile: 'bg-white border-gray-200', testo: 'text-gray-800' },
];

const Voce = ({ v, i, g }) => (
  <div className={`rounded-xl border p-3 ${g.stile}`} data-testid={`ispezione-voce-${i}`}>
    <p className={`text-sm font-semibold ${g.testo}`}>{v.titolo}</p>
    {v.dettaglio && <p className="text-xs text-gray-600 mt-0.5">{v.dettaglio}</p>}
    <p className="text-xs text-gray-700 mt-1.5"><span className="font-semibold">Come sistemare: </span>{v.come}</p>
  </div>
);

export const VociIspezione = ({ voci, aree }) => {
  const nomi = Object.fromEntries(aree.map((a) => [a.area, a.nome]));
  if (!voci.length) {
    return <p className="text-sm text-emerald-700 font-medium" data-testid="ispezione-nessun-problema">Nessun punto da sistemare: registri in ordine.</p>;
  }
  return (
    <div className="space-y-4">
      {GRUPPI.map((g) => {
        const lista = voci.map((v, i) => ({ v, i })).filter((x) => x.v.livello === g.livello);
        if (!lista.length) return null;
        return (
          <div key={g.livello} className="space-y-2" data-testid={`ispezione-gruppo-${g.livello}`}>
            <h4 className="flex items-center gap-2 text-sm font-bold text-gray-900"><g.icona className="h-4 w-4" />{g.titolo} ({lista.length})</h4>
            {lista.map(({ v, i }) => (
              <div key={i}>
                <p className="text-[11px] uppercase tracking-wide text-gray-500 mb-1">{nomi[v.area]}</p>
                <Voce v={v} i={i} g={g} />
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

// Cose che l'app non può vedere: da spuntare a mano prima della visita (non salvate)
export const ControlliManuali = ({ elenco }) => {
  const [fatti, setFatti] = useState({});
  return (
    <div className="space-y-1.5" data-testid="ispezione-manuali">
      {elenco.map((testo, i) => (
        <button key={i} type="button" onClick={() => setFatti((f) => ({ ...f, [i]: !f[i] }))} data-testid={`ispezione-manuale-${i}`}
          className="w-full flex items-start gap-2 text-left text-sm text-gray-800 bg-white border border-gray-200 rounded-lg p-2.5">
          {fatti[i] ? <CheckSquare className="h-4 w-4 mt-0.5 text-emerald-600 shrink-0" /> : <Square className="h-4 w-4 mt-0.5 text-gray-400 shrink-0" />}
          <span className={fatti[i] ? 'line-through text-gray-400' : ''}>{testo}</span>
        </button>
      ))}
    </div>
  );
};
